import PropTypes from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const FormField = ({ label, children, required = false, helperText }) => (
	<Box
		sx={{
			display: 'grid',
			gridTemplateColumns: '160px minmax(0, 1fr)',
			gap: '12px',
			alignItems: 'flex-start',
			py: '7px',
		}}
	>
		<Typography
			component='label'
			sx={{
				fontSize: '11px',
				fontWeight: 500,
				color: 'text.secondary',
				pt: '9px',
				display: 'flex',
				alignItems: 'center',
				gap: '4px',
			}}
		>
			{label}
			{required && (
				<Box component='span' sx={{ color: 'error.main', ml: '2px' }}>
					*
				</Box>
			)}
			{helperText && (
				<Tooltip title={helperText} placement='top' arrow>
					<InfoOutlinedIcon
						sx={{
							fontSize: 13,
							color: 'text.secondary',
							cursor: 'help',
							flexShrink: 0,
						}}
					/>
				</Tooltip>
			)}
		</Typography>

		<Box sx={{ minWidth: 0 }}>{children}</Box>
	</Box>
);

FormField.propTypes = {
	label: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	required: PropTypes.bool,
	helperText: PropTypes.string,
};

export default FormField;
